module.exports = __webpack_public_path__ + "img/Nora-login.99653e.svg";